module.exports = __webpack_public_path__ + "static/RobotoMono-Regular-f9af722836b89d93962accc9a32659fe.woff2";